var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchGzippedFile } from "../../../common";
import { convertNprojToRegisterItem } from "../../../common/nproj/nprojToRegisterItem";
import { makeLegacyPdfUrl } from "./getLegacyAttachment";
import PaperHubDownloadManager from "./PaperHubDownloadManager";
/**
 *
 *
 * @export
 * @param {IPageSOBP} sobp
 * @returns {*}
 */
export default function downloadPaper(sobp) {
    return __awaiter(this, void 0, void 0, function* () {
        // 2021/08/12
        // 캐쉬에서 먼저 찾는다.
        const pfm = PaperHubDownloadManager.getInstance();
        const ret = yield pfm.getCachedNprojAndPdf(sobp);
        return ret;
    });
}
// 2021/08/12
export function retreivePaperInfoFromNprojSync(nproj, nprojUrl, pdf_url = null) {
    const ret = convertNprojToRegisterItem(nproj, {
        getPdfUrlFn: pdf_url ? () => { return pdf_url; } : makeLegacyPdfUrl,
        nproj_url: nprojUrl,
    });
    return ret;
}
export function retreivePaperInfoFromNproj(nprojUrl, pdf_url = null) {
    return __awaiter(this, void 0, void 0, function* () {
        // const { json: accessTokenJson } = await requestAccessToken_AppCredential_ndp();
        // const { access_token } = accessTokenJson;
        // console.log(`access_token: ${access_token}`)
        const AuthTokenStorageKey = '__OTL_Authentication_Token__';
        const token = sessionStorage.getItem(AuthTokenStorageKey);
        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/xml',
                'X-Auth-Token': token,
                // 'Content-Type': 'multipart/form-data',
                // 'Authorization': `bearer ${access_token}`,
            },
        };
        const gz_ext = /.gz$/;
        try {
            console.log(`NPROJ LOADER: download ${nprojUrl}`);
            let nproj;
            if (gz_ext.test(nprojUrl)) {
                // .gz으로 끝나는 파일이면, gzip을 풀어서 읽고
                nproj = yield fetchGzippedFile(nprojUrl, options);
            }
            else {
                // 일반 text 파일이면 text로 바로 읽어 온다.
                // console.log(nprojUrl);
                let response = null;
                let retryCount = 15;
                while ((!response || !response.ok) && retryCount > 0) {
                    response = yield fetch(nprojUrl, options);
                    retryCount--;
                }
                if (!response || !response.ok) {
                    throw new Error("#40002 Network Error NPROJ");
                }
                nproj = yield response.text();
            }
            // const json = nprojToJson(nproj);
            // console.log(json);
            const ret = convertNprojToRegisterItem(nproj, {
                getPdfUrlFn: pdf_url ? () => { return pdf_url; } : makeLegacyPdfUrl,
                nproj_url: nprojUrl,
            });
            return ret;
        }
        catch (e) {
            console.error("HTTP-error: ", e);
        }
        return undefined;
    });
}
//# sourceMappingURL=downloadPaper.js.map